import { selectBalancingOutskirtUnlockLevel } from "../balancingSelectors/selectBalancingOutskirts";
import { IdOutskirtBuildings } from "../constants/IdOutskirtBuildings";
import { warn } from "../utils/logging/logging";
import { selectPlayerLevel } from "./selectPlayerLevelInfo";
export var selectCafeInfo = function (state) {
    warn("Cafe not implemented!");
};
export var selectIsQualifiedForCafe = function (state) {
    var level = selectPlayerLevel(state);
    return level >= selectBalancingOutskirtUnlockLevel(IdOutskirtBuildings.Cafe);
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectCafeInfo.ts
// module id = 2154
// module chunks = 3